import "./Privacy.module.css";
import Header from "@/reusable_sections/Header";
import PrivacyPolicy from "./sections/PrivacyPolicy";
import RaccoltaDeiDatiPersonali from "./sections/RaccoltaDeiDatiPersonali";
import UserRights from "./sections/UserRights";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPage() {
  return <div>
      <Header />
      <PrivacyPolicy />
      <RaccoltaDeiDatiPersonali />
      <UserRights />
      <Footer />
    </div>;
}